import * as _ from 'lodash'
import {scaleLinear as d3scaleLinear} from 'd3-scale'

function allQuestionsAnsweredInSection(survey, sectionId) {
  let allAnswered = true
  _.each(survey[sectionId].questions, question => {
    if(question.chosenAnswer === null)
      allAnswered = false
  })
  return allAnswered
}

function numberOfUnansweredInSection(survey, sectionId) {
  let unanswered = 0
  _.each(survey[sectionId].questions, question => {
    if(question.chosenAnswer === null)
    unanswered++
  })
  return unanswered
}

function allQuestionsAnswered(survey, fieldname) {
  let allAnswered = true

  _.each(survey, section => {
    _.each(section.questions, question => {
      if(question[fieldname] === null)
        allAnswered = false
    })
  })

  return allAnswered
}

function getNormalisedSubtotal(survey, fieldname, sectionId) {
  const section = survey[sectionId]

  let subtotal = _.reduce(section.questions, (sum, question) => {
    var answer = question.answers[question[fieldname]]
    return sum + answer.value
  }, 0)

  subtotal = subtotal / section.normaliseFactor

  // console.log('subtotal', fieldname, sectionId, subtotal)

  return subtotal
}

function getTotalScore(survey, fieldname) {
  // console.log(survey)

  if(!allQuestionsAnswered(survey, fieldname)) {
    return null
  }

  let total = _.reduce(survey, (sum, section) => {
    // console.log(section)
    let normalisedSubtotal = getNormalisedSubtotal(survey, fieldname, section.id)

    return sum + section.weight * normalisedSubtotal
  }, 0)

  return total
}

function getBalance(survey, fieldname) {
  const score = getTotalScore(survey, fieldname)

  return score === null ? 'unknown' : score < 0.35 ? 'ok' : score < 0.6 ? 'poob' : 'oob'
}

function getBalanceString(balanceCode) {
  return balanceCode === 'ok' ? 'In balance' : balanceCode === 'poob' ? 'Possibly out of balance' : balanceCode === 'oob' ? 'Out of balance' : 'Unknown'
}

function balanceHasImproved(survey, prevBalance) {
  // Returns whether current balance has improved
  const newBalance = getBalance(survey, 'chosenAnswer')
  // const originalBalance = getBalance(survey, 'originalChosenAnswer')

  let ret = 'none'
  if(prevBalance === 'oob' && newBalance === 'poob') {
    ret = 'oobToPoob'
  } else if(prevBalance === 'poob' && newBalance === 'ok') {
    ret = 'poobToOk'
  }

  return ret
}

function getNTopQuestionsWithHighestWeightedScore(survey, fieldname, n) {
  var questions = []

  _.each(survey, section => {
    _.each(section.questions, question => {
      var answerValue = question.answers[question[fieldname]].value
      var weightedValue = section.weight * answerValue / section.normaliseFactor
      questions.push({
        sectionId: section.id,
        questionId: question.id,
        // question: question,
        weightedValue: weightedValue
      })
    })
  })

  questions = _.filter(questions, d => d.weightedValue > 0)
  questions = _.sortBy(questions, d => -d.weightedValue)
  questions = questions.slice(0, 5)

  // console.log(questions)

  return questions
}

function getQuestionsWithHighestAnswer(survey, fieldname) {
  const questionsWithHighestAnswer = []

  // console.log(fieldname)

  _.each(survey, section => {
    _.each(section.questions, question => {
      // console.log(section, question)
      var answerValue = question.answers[question[fieldname]].value
      var highestValueAnswer = _.maxBy(question.answers, d => d.value).value

      if(answerValue === highestValueAnswer) {
        questionsWithHighestAnswer.push({
          sectionId: section.id,
          questionId: question.id
        })
      }
    })
  })
  return questionsWithHighestAnswer
}

function questionIsFlagged(sectionId, questionId, flaggedQuestions) {
  let flagged = false
  _.each(flaggedQuestions, fq => {
    if(sectionId === fq.sectionId && questionId === fq.questionId)
      flagged = true
  })
  return flagged
}

function sectionContainsFlaggedQuestion(sectionId, flaggedQuestions) {
  let flagged = false
  _.each(flaggedQuestions, fq => {
    if(sectionId === fq.sectionId)
      flagged = true
  })
  return flagged
}

function getChangedAnswers(survey) {
  // Returns an array of questions where the user's answer is different to the original answer
  let changedAnswers = []
  _.each(survey, section => {
    _.each(section.questions, q => {
      if(q.originalChosenAnswer !== q.chosenAnswer)
        changedAnswers.push(q)
    })
  })
  return changedAnswers
}

function getImageRotation(survey, fieldname) {
  let score = getTotalScore(survey, fieldname)
  let balance = getBalance(survey, fieldname)
  // console.log(fieldname, score, balance)

  let rotateScale = d3scaleLinear()

  if(balance === 'oob') {
    // Score between 0.6 and 1
    // Rotation between 10 and 25 deg
    rotateScale.domain([0.6, 1]).range([10, 25])
  } else if(balance === 'poob') {
    // Score between 0.35 and 0.6
    // Rotation between -3 and 16
    rotateScale.domain([0.35, 0.6]).range([-3, 20])
  } else {
    return 1 /* 'good' image isn't quite straight! */
  }

  return rotateScale(score)
}

export default {
  allQuestionsAnsweredInSection: allQuestionsAnsweredInSection,
  numberOfUnansweredInSection: numberOfUnansweredInSection,
  allQuestionsAnswered: allQuestionsAnswered,
  getNormalisedSubtotal: getNormalisedSubtotal,
  getTotalScore: getTotalScore,
  getBalance: getBalance,
  getBalanceString: getBalanceString,
  balanceHasImproved: balanceHasImproved,
  getNTopQuestionsWithHighestWeightedScore: getNTopQuestionsWithHighestWeightedScore,
  getQuestionsWithHighestAnswer: getQuestionsWithHighestAnswer,
  questionIsFlagged: questionIsFlagged,
  sectionContainsFlaggedQuestion: sectionContainsFlaggedQuestion,
  getChangedAnswers: getChangedAnswers,
  getImageRotation: getImageRotation
}



// WEBPACK FOOTER //
// ./src/Logic/index.js